module.exports = __webpack_public_path__ + "static/kakuro2-daf4f329bc5f4e25ee7bd9252b798370.png";